import axiosApi from '../../axios/axios-api'

const state = {
  numerosRecepcionResumen: [],
  numerosRecepcion: [],
  numerosRecepcionLlamados: []
}
const mutations = {
  setNumerosRecepcionResumen: (state, payload) => {
    state.numerosRecepcionResumen = payload
  },
  setNumerosRecepcion: (state, payload) => {
    state.numerosRecepcion = payload
  },
  setNumerosRecepcionLlamados: (state, payload) => {
    state.numerosRecepcionLlamados = payload
  }
}
const actions = {
  setNumerosRecepcion: ({ commit }, payload) => {
    commit('setNumerosRecepcion', payload)
  },
  fetchNumerosRecepcion: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axiosApi.post('Recepcion/NumerosPorLlamar', data).then(response => {
        var responseData = response.data
        var list = responseData.data
        commit('setNumerosRecepcion', list)
        resolve(list)
      })
    })
  },
  setNumerosRecepcionResumen: ({ commit }, payload) => {
    commit('setNumerosRecepcionResumen', payload)
  },
  fetchNumerosRecepcionResumen: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axiosApi.get(`Recepcion/ResumenNumerosPorLlamar?salaId=${data.salaId}&puestoId=${data.puestoId}`).then(response => {
        var responseData = response.data
        var list = responseData.data
        commit('setNumerosRecepcionResumen', list)
        resolve(list)
      })
    })
  },
  setNumerosRecepcionLlamados: ({ commit }, payload) => {
    commit('setNumerosRecepcionLlamados', payload)
  },
  fetchNumerosRecepcionLlamados: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axiosApi.get(`Recepcion/NumerosLlamados?puestoId=${data.puestoId}`, data).then(response => {
        var responseData = response.data
        var list = responseData.data
        commit('setNumerosRecepcionLlamados', list)
        resolve(list)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
